import moment from 'moment';

export function calculateAge(birthdate: string, targetDate: string = moment().format('YYYY-MM-DD')): number {
  const birthdateMoment = moment(birthdate);
  const targetDateMoment = moment(targetDate);
  const ageInMilliseconds = targetDateMoment.diff(birthdateMoment);
  const ageInYears = moment.duration(ageInMilliseconds).asYears();
  return Math.floor(ageInYears);
}
